import axiosClient from "../../../../system/helpers/axiosConfig";
export const getCategories = () => {
  return axiosClient.get("/api/im/create").then((r) => r.data);
};
